var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center" } },
    [
      _c(
        "el-transfer",
        {
          staticStyle: { "text-align": "left", display: "inline-block" },
          attrs: {
            "left-default-checked": [],
            "right-default-checked": [],
            "render-content": _vm.renderFunc,
            titles: ["选择项目", "已选项目"],
            "button-texts": ["到左边", "到右边"],
            format: {
              noChecked: "${total}",
              hasChecked: "${checked}/${total}",
            },
            data: _vm.data,
            filterable: "",
          },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "right-footer" }, slot: "right-footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.getProjectName },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }